import { useCurrentUser } from 'api';
import { type ReactNode } from 'react';

import { I18nProvider } from './I18nProvider';
import { resolveLanguage } from './resolveLanguage';
import type { I18nNamespace, I18nResources } from './types';

export const I18nWithUserLanguage = <Namespaces extends I18nNamespace>({
  children,
  resources,
}: {
  children: ReactNode;
  resources: I18nResources<Namespaces>;
}) => {
  const { data: user } = useCurrentUser();

  return (
    <I18nProvider resources={resources} language={resolveLanguage(user?.language)}>
      {children}
    </I18nProvider>
  );
};
